export const GET_CONFIG = "GET_CONFIG";

export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const UPDATE_CUSTOMER = 'REMOVE_CUSTOMER';
export const GET_GAMES = 'GET_GAMES';
export const GET_GAME = 'GET_GAME';
export const GET_SERVERS = 'GET_SERVERS';

export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';

export const POSTING_LOADING = 'POSTING_LOADING';
export const CLEAR_LOADING = 'CLEAR_LOADING';
export const BEGIN_LOADING = 'BEGIN_LOADING';

export const POST_QUESTION = 'POST_QUESTION';
export const GET_QUESTION_BY_CHECKID = 'GET_QUESTION_BY_CHECKID';
export const GET_QUESTION_BY_ID = 'GET_QUESTION_BY_ID';
export const GET_QUESTION_LIST = 'GET_QUESTION_LIST';

export const QUESTION_INIT_SETUP = 'QUESTION_INIT_SETUP';
export const GET_USER_BY_TOKEN = 'GET_USER_BY_TOKEN';

export const FOCUS_REPLY = 'FOCUS_REPLY';
export const GET_REPLIES = 'GET_REPLIES';
export const CLOSE_QUESTION = 'CLOSE_QUESTION';

export const RENDER_CREATE_FORM = 'RENDER_CREATE_FORM';
export const CREATE_WEB_REPORT = 'CREATE_WEB_REPORT';

export const POST_CSAT = 'POST_CSAT';

export const EVENT_LOAD_USER = 'EVENT_LOAD_USER';
export const REDEEM_SERIAL = 'REDEEM_SERIAL';

export const POST_VIP_ORDER = 'POST_VIP_ORDER';

export const CHECK_WIRE_REPORT_TOKEN = 'CHECK_WIRE_REPORT_TOKEN';

export const DELIVEROO_VERIFY = 'DELIVEROO_VERIFY';
export const DELIVEROO_RESET = 'DELIVEROO_RESET';

export const GET_VIP_PRODUCTS = 'GET_VIP_PRODUCTS';

export const GET_FAQ = 'GET_FAQ';

export const VIP_GET_QUESTION_BY_CHECKID = 'VIP_GET_QUESTION_BY_CHECKID';
export const VIP_GET_QUESTION_BY_ID = 'VIP_GET_QUESTION_BY_ID';
export const VIP_GET_QUESTION_LIST = 'VIP_GET_QUESTION_LIST';

export const VIP_QUESTION_INIT_SETUP = 'VIP_QUESTION_INIT_SETUP';

export const VIP_FOCUS_REPLY = 'VIP_FOCUS_REPLY';
export const VIP_GET_REPLIES = 'VIP_GET_REPLIES';
export const VIP_CLOSE_QUESTION = 'VIP_CLOSE_QUESTION';

export const VIP_RENDER_CREATE_FORM = 'VIP_RENDER_CREATE_FORM';
export const VIP_CREATE_WEB_REPORT = 'VIP_CREATE_WEB_REPORT';

export const REWARD_INIT_SETUP = 'REWARD_INIT_SETUP';
export const CREATE_REWARD_FORM = 'CREATE_REWARD_FORM';

export const PLAYERBOARD_INIT_SETUP = 'PLAYERBOARD_INIT_SETUP';
export const PLAYERBOARD_FAVORITES = 'PLAYERBOARD_FAVORITES';
export const PLAYERBOARD_REPORT = 'PLAYERBOARD_REPORT';
export const PLAYERBOARD_RENDER_FORM = 'PLAYERBOARD_RENDER_FORM';
export const PLAYERBOARD_EDIT = 'PLAYERBOARD_EDIT';
export const PLAYERBOARD_PUBLISH = 'PLAYERBOARD_PUBLISH';
export const PLAYERBOARD_CANCEL = 'PLAYERBOARD_CANCEL';
export const PLAYERBOARD_CLEAR_MESSAGE = 'PLAYERBOARD_CLEAR_MESSAGE';
export const PLAYERBOARD_BAN_LIST = 'PLAYERBOARD_BAN_LIST';
export const PLAYERBOARD_BAN_SEARCH = 'PLAYERBOARD_BAN_SEARCH';
export const PLAYERBOARD_PREVIEW_HOME = 'PLAYERBOARD_PREVIEW_HOME';
export const PLAYERBOARD_PREVIEW_EDIT = 'PLAYERBOARD_PREVIEW_EDIT';
